module.exports = __webpack_public_path__ + "assets/header-logo-white.01bd3ef5.svg";